import React, { Component } from 'react';

export default class GroupsBottomBar extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        this.handleNavChange = this.handleNavChange.bind(this);
    }

    handleNavChange(link) {
        this.props.handleNavChange(link.index);
    }

    render() {

        let links = this.props.links;
        let options = [];
        let width = 100 / (links.length != 0 ? links.length : 1) + '%';
        for (var i = 0; i < links.length; i++) {

            let color = (links[i].index === this.props.groupModeIndex ? 'rgba(0, 126, 181, 1)' : 'rgba(0, 0, 0, 0.55)');

            options.push((
                <div className="groups-bottom-bar-icon-container" style={{ width: width }} onClick={this.handleNavChange.bind(null, links[i])}>
                    <div style={{ color: color }} className="groups-bottom-bar-icon-container-inner material-icons">{links[i].icon}</div>
                    <div style={{ color: color }} className="groups-bottom-bar-text">{links[i].label}</div>
                </div>
            ));
        }

        let outerStyle = {};
        if (this.props.isScanMode) {
            outerStyle.bottom = '-6rem';
            outerStyle.pointerEvents = 'none';
        }

        return (
            <div className="groups-bottom-bar-outer" style={outerStyle}>
                {options}
            </div>
        );
    }
}
